var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advantage-item"},[_c(_vm.motions[_vm.motionId],{tag:"component",staticClass:"mb-5",attrs:{"progress":_vm.progress}}),_vm._v(" "),_c('div',{staticClass:"subtitle1 mb-6"},[_vm._v(_vm._s(_vm.item.fields.title))]),_vm._v(" "),_c('div',{staticClass:"body1",domProps:{"innerHTML":_vm._s(_vm.item.fields.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }